import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../../services/auth.service';
import { ConnectionService } from '../../services/connection.service';
import { PreferenceService } from '../../services/preference.service';
import { RoutingService } from '../../services/routing.service';

declare var google: any;

@Component({
  selector: 'google-signin',
  templateUrl: './googlesignin.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class GoogleSigninComponent implements AfterViewInit {
  private clientId: string = '663986953938-70fhdni68hpmitkk456o9509i8vqj0fd.apps.googleusercontent.com';
  public auth2: any;

  constructor(
    private connectionService: ConnectionService,
    public routingService: RoutingService,
    private authService: AuthService,
    private preferenceService: PreferenceService
  ) {}

  ngAfterViewInit() {
    if (!this.authService.getStoredToken()) {
      this.googleInitWeb();
    }
  }

  public googleInitWeb() {
    if ((<any>window).google === undefined) {
      window.onload = () => {
        this.googleRendering();
      };
    } else this.googleRendering();
  }

  private googleRendering() {
    if (this.authService.isLoggedIn) return;
    google.accounts.id.initialize({
      client_id: this.clientId,
      auto_select: true,
      callback: this.handleCredentialResponse.bind(this),
    });

    google.accounts.id.prompt();

    google.accounts.id.renderButton(
      document.getElementById('googleBtn'),
      {
        type: 'standard',
        size: 'large',
        locale: this.preferenceService.$currentLang(),
      } // customization attributes
    );
  }

  private handleCredentialResponse(resp) {
    const responsePayload = jwtDecode(resp.credential);
    this.connectionService.googleValidate((<any>responsePayload).email, resp.credential);
  }
}
